import { render, staticRenderFns } from "./DeviceProps.vue?vue&type=template&id=989d34b8&scoped=true&"
import script from "./DeviceProps.vue?vue&type=script&lang=js&"
export * from "./DeviceProps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989d34b8",
  null
  
)

export default component.exports